import AnalyticsCardLayout from "../wrapper/AnalyticsCardLayout";
import ApexChart, { Props } from "react-apexcharts";
function BarCard(props: BarCardProps) {
  const {
    title,
    series,
    colors,
    details,
    hasGradient,
    height,
    percentageChange,
    ...rest
  } = props;

  const chartConfig = {
    series,
    options: {
      chart: {
        type: "bar" as "bar",
        height: 100,
        // width: "100%",
        stacked: true,
        // events: {
        //   selection: function (chart, e) {
        //     console.log(new Date(e.xaxis.min));
        //   },
        // },
      },
      colors: colors || ["#005F6A", "#00E396", "#CED4DC"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        //   curve: "smooth" as "smooth",
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      fill: {
        // type: hasGradient ? "gradient" : "solid",
        type: "solid",
        gradient: {
          shade: "dark",
          inverseColors: false,
          shadeIntensity: 0.5,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      legend: {
        position: "bottom" as "bottom",
        horizontalAlign: "left" as "left",
      },
      xaxis: {
        categories: rest.xAxis,
      },
      yaxis: {
        show: true,
        seriesName: rest.yAxisLabel,
        labels: {
          show: true,
          showAlways: true,
          title: {
            text: rest.yAxisLabel,
            rotate: -90,
          },
        },
        // seriesName: "rest.yAxisLabel"  as ApexYAxis,
      },
    },
  };
  return (
    <AnalyticsCardLayout
      title={title}
      details={details}
      percentageChange={percentageChange}
      bgcolor={rest.bgcolor}
    >
      <ApexChart
        options={chartConfig.options}
        series={chartConfig.series}
        type={chartConfig.options.chart.type}
        height={300}
      />
    </AnalyticsCardLayout>
  );
}

export default BarCard;
